import { useTenant } from '@emerald-works-nova/auth'
import { useSession } from '@emerald-works/react-auth'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import consts from '../consts'
import { subscriptionSlice, userSlice } from '../reducers'
import useGroup from './useGroup'
import usePaidConsumer from './usePaidConsumer'

const STUDENT_PLAN_CODE = 'mt-student-plan'

const isStudentPlanCode = (planCode) => planCode === STUDENT_PLAN_CODE

const useIsStudentPlan = () => {
  const tenant = useTenant()
  const { isAuthenticated } = useSession()
  const { groups } = useGroup()
  const { isPaidConsumer } = usePaidConsumer()
  const accountInfo = useSelector(subscriptionSlice.selectors.selectAccountInfo)
  const accountInfoLoaded = useSelector(subscriptionSlice.selectors.selectAccountInfoLoaded)
  const profile = useSelector(userSlice.selectors.selectProfile)
  const isProfileLoaded = useSelector(userSlice.selectors.selectIsProfileLoaded)

  const planCode = accountInfo.plan?.id || profile?.subscription?.code
  const isClub = tenant.pk === consts.DEFAULT_CLUB_PK

  const isStudentPlan = useMemo(() => {
    if (!isClub) return false

    if (!isAuthenticated) return false

    if (!isProfileLoaded || groups === undefined) return null

    if (!isPaidConsumer) return false

    if (typeof planCode === 'string') {
      return isStudentPlanCode(planCode)
    }

    if (!accountInfoLoaded) return null

    return false
  }, [isClub, isAuthenticated, isProfileLoaded, groups, isPaidConsumer, planCode, accountInfoLoaded])

  return { isStudentPlan }
}

export { STUDENT_PLAN_CODE, isStudentPlanCode }
export default useIsStudentPlan
